import { inject, signal, Signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';

import { GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

const indexes = {
  index: ['investigator-forecast'] as const,
  metadata: (trialKey: string) => [...indexes.index, 'metadata', trialKey] as const,
};

export const injectInvestigatorForecastMetadata = ({
  enabled = signal(true),
}: {
  enabled?: Signal<boolean>;
} = {}) => {
  const mainQuery = inject(MainQuery);
  const gqlService = inject(GqlService);

  return injectQuery(() => ({
    enabled: enabled(),
    queryFn: () => {
      return gqlToPromise(() => gqlService.getInvestigatorForecastMetadata$());
    },
    queryKey: indexes.metadata(mainQuery.trialKey()),
  }));
};
